import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import videosrc from "../../../../assests/newimages/homevideo.mp4";

export default function HeroSection() {
  return (
    <div
      className="mt-5 px-4"
      style={{
        background: "#fff",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Top hero: headline + description */}
      <section style={{ paddingTop: "clamp(48px, 6vw, 80px)" }}>
        <h1
          style={{
            fontSize: "clamp(2.4rem, 6.5vw, 5.2rem)",
            fontWeight: 600,
            lineHeight: 1,
            color: "#0f0f1a",
            marginTop: 0,
            marginBottom: "clamp(28px, 4vw, 48px)",
            letterSpacing: "-0.03em",
          }}
        >
          Unmask the blockchain,
          <br />
          unlock{" "}
          <span
            className="h-auto xl:h-[85px]"
            style={{
              color: "#7c3aed",
              display: "inline-block",
              border: "2.5px solid #a78bfa",
              borderRadius: "999px",
              padding: "0px 22px 0px",
              fontWeight: 600,
              lineHeight: 1.15,
            }}
          >
            intelligence
          </span>
        </h1>

        <p
          style={{
            fontSize: "clamp(0.9rem, 1.5vw, 1.05rem)",
            color: "#1b152b",
            lineHeight: 1.8,
            maxWidth: 1100,
            margin: 0,
          }}
        >
          Element Us Labs is a pioneering blockchain intelligence platform
          focused on the flow of digital assets across an evolving Web3
          ecosystem. With over 650 million addresses attributed to entities and
          identities across multiple chains, Element Us Labs offers the
          transparency &amp; intelligence needed for actionable insights on the
          blockchain.
        </p>
      </section>

      {/* Bottom section: globe network visualization + CTA card */}
      <section
        style={{
          position: "relative",
          zIndex: 1,
          flex: 1,
          minHeight: "clamp(380px, 52vw, 660px)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          marginTop: "clamp(8px, 2vw, 16px)",
        }}
      >
        {/* Background Video */}
        <video
          autoPlay
          muted
          loop
          playsInline
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 0,
          }}
        >
          <source src={videosrc} type="video/mp4" />
        </video>

        {/* CTA card */}
        <div
          style={{
            position: "absolute",
            bottom: "clamp(24px, 5vw, 56px)",
            left: 0,
            zIndex: 2,
            background: "#13121f",
            borderRadius: "0 54px 54px 0",
            padding: "clamp(28px, 2vw, 44px) clamp(28px, 2vw, 52px)",
            boxSizing: "border-box",
            minHeight:"200px",
            width: "clamp(300px, 50vw, 600px)" 
          }}
        >
          <h2
            style={{
              fontSize: "30px",
              fontWeight: 400,
              color: "#ffffff",
              lineHeight: 1,
              marginBottom:"15px"
            }}
          >
            Blockchain
            <br />
            intelligence is at
            <br />
            your fingertips.
          </h2>

          <Link
            to="/login"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              background: "#7c3aed",
              color: "#fff",
              border: "none",
              borderRadius: 999,
              padding: "14px 24px 14px 28px",
              fontSize: "clamp(0.875rem, 1.4vw, 1rem)",
              fontWeight: 600,
              cursor: "pointer",
              width: "100%",
              justifyContent: "space-between",
              letterSpacing: "0.01em",
              textDecoration: "none",
              boxSizing: "border-box",
              transition: "background 0.2s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#6d28d9")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#7c3aed")}
          >
            <span>Login</span>

            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </section>
    </div>
  );
}
